import { render, staticRenderFns } from "./Sizing.vue?vue&type=template&id=3013d306&scoped=true"
import script from "./Sizing.vue?vue&type=script&lang=js"
export * from "./Sizing.vue?vue&type=script&lang=js"
import style0 from "./Sizing.vue?vue&type=style&index=0&id=3013d306&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3013d306",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {HeaderElementsAccessibilityTranslation: require('/home/travis/build/Polumathes/LTNG-1800-Frontend/components/HeaderElements/Accessibility/Translation.vue').default})
